module.exports = __webpack_public_path__ + "static/media/A7S01282.04464a98.jpg";